import { render, staticRenderFns } from "./VerkaDropdown.vue?vue&type=template&id=6f8d2ba4&scoped=true&"
import script from "./VerkaDropdown.vue?vue&type=script&lang=ts&"
export * from "./VerkaDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaDropdown.vue?vue&type=style&index=0&id=6f8d2ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d2ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VMenu})
